export default "__VITE_ASSET__VHgsln$$__"